import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  TextField,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useState } from "react";
import { MdOutlineHelpOutline, MdOutlineWarningAmber } from "react-icons/md";
import { BRAND, TONE } from "../components/MobileList";

function ConfirmationDialog(props) {
  const {
    open,
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    name,
    type,
    requirePassword = false,
    passwordLabel = "كلمة المرور",
  } = props;

  // `type` set = a normal confirmation, otherwise it is a destructive one.
  const tone = type ? BRAND : TONE.danger;

  const [password, setPassword] = useState("");

  const handleClose = () => {
    setPassword("");
    onCancel();
  };

  const handleConfirm = () => {
    onConfirm(password);
    setPassword("");
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth dir="rtl">
      <DialogContent
        sx={{ bgcolor: "#fff", textAlign: "center", pt: 4, px: 3, pb: 2 }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            mx: "auto",
            mb: 2,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            fontSize: 32,
            color: tone,
            bgcolor: alpha(tone, 0.12),
            boxShadow: `0 0 0 8px ${alpha(tone, 0.06)}`,
          }}
        >
          {type ? <MdOutlineHelpOutline /> : <MdOutlineWarningAmber />}
        </Box>
        <Typography fontSize={18} fontWeight={700} color="#101828">
          {title}
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          {message}
        </Typography>
        {name && (
          <Box
            sx={{
              display: "inline-block",
              mt: 1.5,
              px: 1.5,
              py: 0.5,
              borderRadius: 2,
              fontWeight: 700,
              color: tone,
              bgcolor: alpha(tone, 0.08),
            }}
          >
            {name}
          </Box>
        )}
        {requirePassword && (
          <TextField
            label={passwordLabel}
            type="password"
            fullWidth
            size="small"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            sx={{ mt: 2.5 }}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ borderTop: "none", px: 3, pb: 3, pt: 1 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          fullWidth
          sx={{ color: "#475467", borderColor: "#d0d5dd" }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={handleConfirm}
          color={type ? "primary" : "error"}
          autoFocus={!requirePassword}
          variant="contained"
          fullWidth
          disabled={requirePassword && password.length === 0}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
  requirePassword: PropTypes.bool,
  passwordLabel: PropTypes.string,
};

export default ConfirmationDialog;
